export default "__VITE_ASSET__9a01f244__"